import { Deserializable, JsonObject } from '@ktypes/models';

export class WorkbookRequest implements Deserializable<JsonObject, WorkbookRequest> {
  constructor(public declined?: boolean, public requested?: boolean, public dateOrdered?: string) {}

  deserialize(input: JsonObject): WorkbookRequest {
    if (input == null) {
      return null;
    }
    this.declined = input['declined'];
    this.requested = input['requested'];
    this.dateOrdered = input['dateOrdered'];
    return this;
  }
}
